/* eslint-disable class-methods-use-this */
import { EventEmitter } from 'events';
import { createTocChildren } from './toc-elements';
import { generateDocItems } from './doc-item';
import { saveContentURL, loadContentURL } from './cookie';
import {
  changeTocStatusByURL,
  safeDomControl,
  setElementClass,
  controlListGroup,
  // getContentFrameURL,
} from './dom-utils';
import {
  clearFilter,
  filter,
  doFilter,
} from './filter';
import { isDevelopHost } from './dev-mode';
import {
  createTocContentInfoElement,
  setTocContentInfo,
} from './content-info';
import { trimURL } from './utils';

export class TocManager extends EventEmitter {
  constructor(options) {
    super();
    this.name = 'TOC';
    this.options = options;
    this.__contentURL = null;
    this.__loaded = false;
    this.__listNumber = false;
    this.__groupNumber = false;
    this.__groupStatus = 'custom';
    this.__groupCountBadge = false;
    this.__devMode = isDevelopHost();
    this.filtering = false;
    this.filteredItems = [];
    this.log('DEV_MODE:', this.devMode);
    this.log('SET DATA LENGTH:', this.data.length);
  }

  get data() {
    return this.getOption('data', []);
  }

  get loaded() {
    return this.__loaded;
  }

  set hash(url) {
    let hash;
    if (_.isNil(url)) {
      hash = '';
    } else {
      const prevHash = this.hash.replace(/\.html?$/, '');
      hash = `#${url.replace(/\.html?$/, '')}`;
      if (hash === prevHash) {
        return;
      }
    }
    window.history.replaceState(undefined, undefined, hash);
  }

  get hash() {
    return window.location.hash;
  }

  set contentURL(url) {
    if (url === this.contentURL) {
      return;
    }
    this.__contentURL = url;
    this.hash = url;

    this.setTocContentInfo(url);
    const el = this.contentFrameEl;
    if (!_.isNil(el)) {
      el.src = url;
      this.log('ContentURL:', url);
      // this.log(this.selectedItem);
    }

    if (this.groupStatus !== 'autoCollapse') {
      this.groupStatus = 'custom';
    }
    this.safeTocElementFn($t => {
      changeTocStatusByURL(url, $t, {
        activeTarget: true,
        status: this.groupStatus,
      });
    });
    saveContentURL(url);
  }

  /**
   * @param {string} url
   */
  set hashURL(url) {
    this.__contentURL = url;
    this.hash = url;
    this.setTocContentInfo(url);
    if (this.groupStatus !== 'autoCollapse') {
      this.groupStatus = 'custom';
    }
    this.safeTocElementFn($t => {
      changeTocStatusByURL(url, $t, {
        activeTarget: true,
        status: this.groupStatus,
      });
    });
    saveContentURL(url);
  }

  get contentURL() {
    return this.__contentURL;
  }

  set listNumber(bool) {
    // console.log(this.listNumber, bool);
    if (this.listNumber === bool) {
      return;
    }
    this.__listNumber = bool;
    safeDomControl(this.$docElements, $t => {
      const $el = $t.children('.label');
      setElementClass($el, 'has-num', bool);
    });
    this.__emit('changeListNumber', { value: bool });
  }

  get listNumber() {
    return this.__listNumber;
  }

  set groupCountBadge(bool) {
    if (this.groupCountBadge === bool) {
      return;
    }
    this.__groupCountBadge = bool;
    safeDomControl(this.$groupElements, $t => {
      const $el = $t.children('.label');
      setElementClass($el, 'has-badge', bool);
    });
    this.__emit('changeGroupCountBadge', { value: bool });
  }

  get groupCountBadge() {
    return this.__groupCountBadge;
  }

  set groupNumber(bool) {
    if (this.groupNumber === bool) {
      return;
    }
    this.__groupNumber = bool;
    safeDomControl(this.$groupElements, $t => {
      const $el = $t.children('.label');
      setElementClass($el, 'has-num', bool);
    });
    this.__emit('changeGroupNumber', { value: bool });
  }

  get groupNumber() {
    return this.__groupNumber;
  }

  set groupStatus(status) {
    const prevStatus = this.groupStatus;
    if (prevStatus === status) {
      return;
    }
    const prevClassname = _.kebabCase(prevStatus);
    const $scope = this.$tocElement;
    if ($scope.hasClass(prevClassname)) {
      this.setTocElementClass(prevClassname, false);
    }
    this.setTocElementClass(_.kebabCase(status));
    let controlFn;
    switch (status) {
      case 'default':
      case 'collapseAll':
      case 'expandAll':
      case 'autoCollapse':
        controlFn = controlListGroup;
        break;
      case 'custom':
        break;
      default:
        this.log(`undefined group status: ${status}`);
    }

    if (controlFn) {
      controlFn($scope, status);
    }
    this.__groupStatus = status;
    this.__emit('changeGroupStatus', { value: status });
  }

  get groupStatus() {
    return this.__groupStatus;
  }

  get selectedItem() {
    const url = this.contentURL;
    return this.findDocItem({ url });
  }

  get devMode() {
    return this.__devMode && this.getOption('debug', false);
  }

  getOption(path, def) {
    return _.get(this.options, path, def);
  }

  log(...args) {
    if (!this.devMode) {
      return this;
    }
    try {
      console.log.apply(null, _.concat(
        [
          `%c[${this.name}]`,
          'background: royalblue; color: white',
        ],
        args,
      ));
      return this;
    } catch (err) {
      // nothging
    }
  }

  // 만들기
  create() {
    this.__emit('initBefore');
    const self = this;

    const globalName = this.getOption('global', 'toc');
    window[globalName] = this;

    $(document).ready(() => self.__initDOM());
    this.__emit('initAfter');
    return this;
  }

  __emit(name, data) {
    this.emit(name, _.assignIn({ type: name }, data));
  }

  // @private
  __initDOM() {
    // console.log('* jquery: ', $.fn.jquery);
    // console.log('* lodash: ', _.VERSION);
    this.__emit('createBefore');

    const { contentFrame, elementId } = this.options;

    // #contentFrame
    const contentFrameId = contentFrame.id;
    if (_.isNil(contentFrameId)) {
      throw new Error('required "contentFrame" option property: { id, name }');
    }
    this.contentFrameEl = document.getElementById(contentFrameId);
    // eslint-disable-next-line no-unused-vars

    const selector = `#${elementId}`;
    const $tocEl = $(selector);
    if (!$tocEl.length) {
      throw new Error(`not found element: "${selector}"`);
    }
    this.$tocElement = $tocEl.addClass('IBTocMain');

    this.__createTocContentInfoElement();

    this.__asyncSetDocItems().then(data => {
      this.docItems = data;
    });

    this.__asyncCreateTocElements();

    return this;
  }

  // @private
  __asyncCreateTocElements() {
    const self = this;
    const $tocEl = this.$tocElement;

    // promise
    return createTocChildren(this.data, $children => {
      $tocEl.append($children);

      this.log('CREATED TOC CHILD_ELEMENTS!');

      $tocEl.find('li.md > a.link-item').on('click', function (evt) {
        evt.preventDefault();
        const url = $(this).attr('data-url');
        self.contentURL = url;
        // console.log(url);
      });

      // eslint-disable-next-line prefer-arrow-callback
      $tocEl.find('li.group > a.link-item').on('click', function (evt) {
        evt.preventDefault();
        $(evt.target).parent('li.group').toggleClass('expanded');
        if (self.groupStatus !== 'autoCollapse') {
          self.groupStatus = 'custom';
        }
      });

      this.$docElements = $tocEl.find('li.md');
      this.$groupElements = $tocEl.find('li.group');

      this.__onCreatedElements();
    });
  }

  // @private
  __asyncSetDocItems() {
    return new Promise((resolve, reject) => {
      let items;
      try {
        items = generateDocItems(this.data, undefined, {
          $scopeElement: this.$tocElement,
        });
        this.log(`Init Markdown Items: ${items.length}`);
      } catch (err) {
        reject(err);
      }
      resolve(items);
    });
  }

  __onCreatedElements() {
    this.__setCustomOptions();
    this.__setStartContent();

    const $tocEl = this.$tocElement;
    $tocEl.trigger({
      type: 'createdChildren',
      target: $tocEl[0],
    });
    this.tocInfoElements.wrapper
      .addClass(`active${this.devMode ? ' dev-mode' : ''}`);

    $(window).on('hashchange', () => {
      this.setContentByHash();
    });

    this.__emit('created');
    this.$tocElement.addClass('loaded');
    this.__loaded = true;
  }

  __setCustomOptions() {
    this.groupStatus = this.getOption('groupStatus', 'default');
    this.groupNumber = this.getOption('groupNumber', false);
    this.groupCountBadge = this.getOption('groupCountBadge', false);
    this.listNumber = this.getOption('listNumber', false);
  }

  // @private
  __setStartContent() {
    this.setContentByHash();

    const lastContentURL = loadContentURL();
    if (!_.isNil(lastContentURL) && lastContentURL !== 'undefined') {
      this.contentURL = lastContentURL;
      return;
    }
    const { startPage } = this.options;

    let startContentItem;
    if (!_.isNil(startPage)) {
      startContentItem = this.findDocItem({ name: startPage });
    } else {
      startContentItem = this.findDocItem({ id: 1 });
    }
    this.setContentByItem(startContentItem);
  }

  safeTocElementFn(callback) {
    safeDomControl(this.$tocElement, callback);
  }

  setTocElementClass(classname, bool) {
    this.safeTocElementFn($t => {
      setElementClass($t, classname, bool);
    });
  }

  findDocItem(options) {
    return _.find(this.docItems, options);
  }

  setContentById(id) {
    const item = this.findDocItem({ id });
    return this.setContentByItem(item);
  }

  setContentByName(name) {
    const item = this.findDocItem({ name });
    return this.setContentByItem(item);
  }

  setContentByURL(url) {
    // console.log(url);
    url = trimURL(url);
    const item = this.findDocItem({ url });
    if (_.isNil(item)) {
      return;
    }
    return this.setContentByItem(item);
  }

  setContentByHash() {
    const hash = this.hash;
    let item;
    if (hash.length) {
      const url = _.trim(`${hash.replace(/^#*/, '')}.html`);
      item = this.findDocItem({ url });
      if (!_.isNil(item)) {
        this.setContentByItem(item);
      }
    }
  }

  setContentByItem(item) {
    if (!_.hasIn(item, 'url')) {
      throw new Error(`"${item.name}" has not "url" property.`);
    }
    const url = item.url;
    this.contentURL = url;
    return this;
  }

  // md-content 로드 시 url 변경 하는 메소드. iframe의 src는 안바꿈
  setHashByURL(url) {
    url = trimURL(url);
    const item = this.findDocItem({ url });
    if (_.isNil(item)) {
      return;
    }

    if (!_.hasIn(item, 'url')) {
      throw new Error(`"${item.name}" has not "url" property.`);
    }
    url = item.url;
    this.hashURL = url;
    return true;
  }
}

const fn = TocManager.prototype;
fn.clearFilter = clearFilter;
fn.filter = filter;
fn.__doFilter = doFilter;
fn.__createTocContentInfoElement = createTocContentInfoElement;
fn.setTocContentInfo = setTocContentInfo;
